export type MetricUnavailableReason =
  | "insufficient-sample"
  | "insufficient-eligible-observations"
  | "invalid-input"
  | "zero-variance"
  | "unstable-estimate"
  | "non-mean-reverting"
  | "half-life-not-defined"
  | "half-life-exceeds-window"
  | "wide-confidence-interval"
  | "stationarity-not-supported"
  | "low-data-quality"
  | "formal-analysis-not-permitted"
  | "unsupported-template";

export interface AvailableMetric<T> {
  readonly status: "available";
  readonly value: T;
  readonly sampleSize: number;
  readonly method: string;
  readonly warnings: readonly string[];
}
export interface UnavailableMetric {
  readonly status: "not-available";
  readonly reason: MetricUnavailableReason;
  readonly detail: string;
  readonly sampleSize: number;
  readonly method?: string;
}

export type MetricResult<T> = AvailableMetric<T> | UnavailableMetric;

export function available<T>(
  value: T,
  sampleSize: number,
  method: string,
  warnings: readonly string[] = [],
): AvailableMetric<T> {
  return { status: "available", value, sampleSize, method, warnings };
}

export function notAvailable(
  reason: MetricUnavailableReason,
  detail: string,
  sampleSize: number,
  method?: string,
): UnavailableMetric {
  return { status: "not-available", reason, detail, sampleSize, ...(method ? { method } : {}) };
}
